import { schema } from 'normalizr';

export const advertiserAd = new schema.Entity('advertiserAd');
export const settings = new schema.Entity('settings');
export const advertiserCampaign = new schema.Entity('advertiserCampaign');
export const adminCreative = new schema.Entity(
  'adminCreative',
  {},
  { idAttribute: 'creative_service_id' }
);
export const user = new schema.Entity('user');
export const userSales = new schema.Entity('userSales');
export const userAdmin = new schema.Entity('userAdmin');
export const advertiser = new schema.Entity('advertiser', {}, { idAttribute: 'uuid' });
export const location = new schema.Entity('location', {}, { idAttribute: 'location_id' });
export const app = new schema.Entity('app');
export const forecast = new schema.Entity('forecast');
export const forecastRevision = new schema.Entity(
  'forecastRevision',
  {},
  { idAttribute: 'revision_id' }
);
export const forecastRevisionAudience = new schema.Entity('forecastRevisionAudience');
export const chain = new schema.Entity('chain', {}, { idAttribute: 'chain_id' });
export const state = new schema.Entity('state', {}, { idAttribute: 'state_code' });
export const dma = new schema.Entity('dma', {}, { idAttribute: 'dma_id' });
export const beacon = new schema.Entity('beacon', {}, { idAttribute: 'beacon_id' });
export const advertiserAdAlcohol = new schema.Entity(
  'advertiserAdAlcohol',
  {},
  { idAttribute: 'advertiser_ad_id' }
);
export const publisher = new schema.Entity('publisher', {}, { idAttribute: 'uuid' });
export const forecastRevisionLocation = new schema.Entity(
  'forecastRevisionLocation',
  {},
  { idAttribute: 'location_id' }
);
export const forecastRevisionApp = new schema.Entity(
  'forecastRevisionApp',
  {},
  { idAttribute: 'app_id' }
);
export const forecastRevisionChain = new schema.Entity(
  'forecastRevisionChain',
  {},
  { idAttribute: 'chain_id' }
);
export const forecastRevisionState = new schema.Entity(
  'forecastRevisionState',
  {},
  { idAttribute: 'state_code' }
);
export const advertiserAdLocation = new schema.Entity(
  'advertiserAdLocation',
  {},
  { idAttribute: 'location_id' }
);
export const advertiserAdApp = new schema.Entity('advertiserAdApp', {}, { idAttribute: 'app_id' });
export const advertiserAdChain = new schema.Entity(
  'advertiserAdChain',
  {},
  { idAttribute: 'chain_id' }
);
export const advertiserAdState = new schema.Entity(
  'advertiserAdState',
  {},
  { idAttribute: 'state_code' }
);
export const advertiserAdDma = new schema.Entity('advertiserAdDma', {}, { idAttribute: 'dma_id' });
export const advertiserAdProduct = new schema.Entity(
  'advertiserAdProduct',
  {},
  { idAttribute: 'product_id' }
);
export const advertiserAdCheckinCreative = new schema.Entity(
  'advertiserAdCheckinCreative',
  {},
  { idAttribute: 'action_media_id' }
);
export const advertiserAdInhandCreative = new schema.Entity(
  'advertiserAdInhandCreative',
  {},
  { idAttribute: 'creative_id' }
);
export const advertiserAdInhand = new schema.Entity(
  'advertiserAdInhand',
  {},
  { idAttribute: 'product_id' }
);
export const advertiserAdBeacon = new schema.Entity(
  'advertiserAdBeacon',
  {},
  { idAttribute: 'beacon_id' }
);
export const advertiserCampaignAdvertiserAd = new schema.Entity('advertiserCampaignAdvertiserAd');
export const advertiserAdInstore = new schema.Entity(
  'advertiserAdInstore',
  {},
  { idAttribute: 'advertiser_ad_id' }
);
export const theTradeDeskCheck = new schema.Entity(
  'theTradeDeskCheck',
  {},
  { idAttribute: 'uuid' }
);
export const theTradeDeskQuery = new schema.Entity(
  'theTradeDeskQuery',
  {},
  { idAttribute: 'uuid' }
);
export const advertiserAdAudiences = new schema.Entity(
  'advertiserAdAudiences',
  {},
  { idAttribute: 'advertiser_ad_id' }
);
export const advertiserAdAudiencesVerify = new schema.Entity(
  'advertiserAdAudiencesVerify',
  {},
  { idAttribute: 'advertiser_ad_id' }
);
